
import { defineComponent } from 'vue'

const __default__ = defineComponent({
    name: 'TechnoFrame',

    data(): {
        corner: {
            width: number
            height: number
        },
        line: {
            width: number
            height: number
        },
    } {
        return {
            corner: {
                width: 350,
                height: 180,
            },

            line: {
                width: 64,
                height: 64,
            }
        }
    },

    props: {
        offset: {
            type: Number,
            required: true,
        },

        sizeModifier: {
            type: Number,
            default: 1,
        },
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0a2a5cf2": ((_ctx.line.height * _ctx.sizeModifier) + "px"),
  "8f861bf6": ((_ctx.line.width * _ctx.sizeModifier) + "px"),
  "1bb1eb84": ((_ctx.corner.width * _ctx.sizeModifier) + "px"),
  "15549353": ((_ctx.corner.height * _ctx.sizeModifier) + "px")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__